import { green, grey, red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

export default createTheme({
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontSize: '0.875rem',
                    lineHeight: 1.43,
                    letterSpacing: '0.01071em',
                },
            },
        },
        MuiBreadcrumbs: {
            styleOverrides: {
                separator: {
                    marginLeft: 0,
                    marginRight: 0,
                },
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    padding: '0px 10px 0px 0px',
                },
                content: {
                    paddingBottom: 0,
                    margin: 0,
                },
            }
        },
        MuiDialogContentText: {
            styleOverrides: {
                root: {
                    fontSize: '0.8rem',
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                variant: 'standard',
            }
        },
        MuiFab: {
            styleOverrides: {
                root: {
                    height: 32,
                }
            }
        },



        MuiSelect: {
            styleOverrides: {
                select: {
                    'white-space': 'break-spaces',
                }
            }
        },
        MuiButton: {
            defaultProps: {
                variant: 'contained',
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    padding: 5,
                    paddingRight: 7,
                    paddingLeft: 7,
                    textTransform: 'capitalize',
                    boxShadow: 'none',
                    fontSize: '0.75rem',
                    '&:hover': {
                        boxShadow: 'none',
                        background: 'rgba(0,0,0,0.1)',
                    },
                },
                containedPrimary: {
                    boxShadow: 'none',
                    color: '#3f51b5',
                    backgroundColor: 'transparent',
                    '&:hover': {
                        boxShadow: 'none',
                        background: 'rgba(63,81,181,0.5)',
                    },
                    '&.Mui-disabled': {
                        background: '#7e7e7e',
                        color: '#c0c0c0'
                    },
                },
                textPrimary: {
                    color: '#FFF',
                    fontWeight: 'normal',
                }
            }
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    fontSize: '0.9rem',
                },
            }
        },
        MuiSwitch: {
            styleOverrides: {
                thumb: {
                    color: grey[500],
                },
                track: {
                    backgroundColor: red[500],
                    opacity: 1.0,
                    '.Mui-checked.Mui-checked + &': {
                        backgroundColor: green[500]
                    }
                },
            },
        },
    }
});